<template>
    <modeler-base title="File Explorer" :loading="loading" :loading-text="loadingText">
        <div id="explorer-button-bar" slot="button-bar">
            <ButtonIconWithText :icon="$icons.fileNew" text="New" :click="handleNew"/>
            <ButtonIconWithText :icon="$icons.fileOpen" text="Open" :click="handleOpen" :disabled="!getSelectedModel()"/>
            <ButtonIconWithText :icon="$icons.fileCopy" text="Copy" :click="handleCopy" :disabled="!getSelectedModel()"/>
            <ButtonIconWithText :icon="$icons.fileDelete" text="Delete" :click="handleDelete" :disabled="!getSelectedModel()"/>
            <ButtonIconWithText :icon="$icons.fileLink" text="Send" :click="handleSend" :disabled="!getSelectedModel()"/>
        </div>
        <div slot="body" id="explorer-body"
             v-loading="$apollo.queries.modelsOwned.loading" element-loading-text="Loading models">
            <!--PLACEHOLDER (HIGH) implement server-side search capability-->
            <el-input
                    class="search-models"
                    size="small"
                    placeholder="Search model names and numbers"
                    v-model="filterText"
                    ref="filterText"
                    clearable>
            </el-input>
            <span id="explorer-models">
                <el-radio-group id="model-radio-group" v-model="radio" size="small" @change="handleChangeRadio">
                    <!--style="width: 50px;"-->
                    <el-radio-button :label="0">
                        <span class="radio-text">Recently opened</span>
                    </el-radio-button>
                    <el-radio-button :label="1">
                        <span class="radio-text">Owned by me</span>
                    </el-radio-button>
                    <el-radio-button :label="2">
                        <span class="radio-text">Shared with me</span>
                    </el-radio-button>
                    <!--FUTURE CONSIDERATION-->
                    <!--<el-radio-button :label="3">-->
                    <!--<span class="radio-text">Projects</span>-->
                    <!--</el-radio-button>-->
                </el-radio-group>
                <div class="table-wrap">
                    <el-table
                            size="mini"
                            style="cursor: default;"
                            height="calc(100vh - var(--ribbon-height) - 121px)"
                            :data="tableModels.filter(item => !filterText || item.name.toLowerCase().includes(filterText.toLowerCase()) || searchNumber(item, filterText))"
                            :empty-text="tableEmptyText"
                            ref="tableModels"
                            highlight-current-row
                            @row-dblclick="handleOpen"
                            @current-change="handleCurrentChange"
                    >
                    <el-table-column
                            min-width="140"
                            property="name"
                            label="Name"
                            sortable
                            show-tooltip-when-overflow
                    >
                    </el-table-column>
                    <el-table-column
                            min-width="70"
                            property="number"
                            label="Number"
                            sortable
                            show-tooltip-when-overflow
                    >
                    </el-table-column>
                    <el-table-column
                            width="160"
                            property="lastModifiedOn"
                            :formatter="formatterDatetime"
                            label="Modified on"
                            sortable
                    >
                    </el-table-column>

                        <!--region DEPRECATED table icons and buttons-->
                        <!--<el-table-column-->
                        <!--width="57"-->
                        <!--align="center"-->
                        <!--label="Info">-->
                        <!--&lt;!&ndash;property="info"&ndash;&gt;-->
                        <!--<template slot-scope="scope">-->
                        <!--<el-tooltip :enterable="false">-->
                        <!--<span slot="content">-->
                        <!--&lt;!&ndash;SPAN ALSO GIVES DESIRED ROW SPACING&ndash;&gt;-->
                        <!--<table id="table-file-info">-->
                        <!--<tr>-->
                        <!--<td>Description:</td>-->
                        <!--<td>{{scope.row.description}}</td>-->
                        <!--</tr>-->
                        <!--<tr>-->
                        <!--<td><hr style="border: var(&#45;&#45;border-color) solid 1px;"></td>-->
                        <!--<td><hr style="border: var(&#45;&#45;border-color) solid 1px;"></td>-->
                        <!--</tr>-->
                        <!--<tr>-->
                        <!--<td>Owner:</td>-->
                        <!--<td>{{scope.row.owner.name}}</td>-->
                        <!--</tr>-->
                        <!--<tr>-->
                        <!--<td>Locked:</td>-->
                        <!--<td>{{scope.row.lock}}</td>-->
                        <!--</tr>-->
                        <!--<tr>-->
                        <!--<td><hr style="border: var(&#45;&#45;border-color) solid 1px;"></td>-->
                        <!--<td><hr style="border: var(&#45;&#45;border-color) solid 1px;"></td>-->
                        <!--</tr>-->
                        <!--<tr>-->
                        <!--<td>Created on:</td>-->
                        <!--<td>{{scope.row.createdOn}}</td>-->
                        <!--</tr>-->
                        <!--<tr>-->
                        <!--<td>Created by:</td>-->
                        <!--<td>{{scope.row.createdBy}}</td>-->
                        <!--</tr>-->
                        <!--<tr>-->
                        <!--<td><hr style="border: var(&#45;&#45;border-color) solid 1px;"></td>-->
                        <!--<td><hr style="border: var(&#45;&#45;border-color) solid 1px;"></td>-->
                        <!--</tr>-->
                        <!--<tr>-->
                        <!--<td>Last modified on:</td>-->
                        <!--<td>{{scope.row.modifiedOn}}</td>-->
                        <!--</tr>-->
                        <!--<tr>-->
                        <!--<td>Last modified by:</td>-->
                        <!--<td>{{scope.row.modifiedBy}}</td>-->
                        <!--</tr>-->
                        <!--</table>-->
                        <!--</span>-->
                        <!--<i class="el-icon-info table-icon-btn"></i>-->
                        <!--</el-tooltip>-->
                        <!--</template>-->
                        <!--</el-table-column>-->

                        <!--<el-table-column-->
                        <!--width="57"-->
                        <!--align="center"-->
                        <!--label="Open"-->
                        <!--fixed="right">-->
                        <!--<template slot-scope="scope">-->
                        <!--<el-button class="table-icon-btn" type="text" @click="handleEdit(scope.$index, scope.row.uid)">-->
                        <!--<i class="el-icon-edit-outline"></i>-->
                        <!--</el-button>-->
                        <!--</template>-->
                        <!--</el-table-column>-->

                        <!--<el-table-column-->
                        <!--width="57"-->
                        <!--align="center"-->
                        <!--label="Delete"-->
                        <!--fixed="right">-->
                        <!--<template slot-scope="scope">-->
                        <!--<el-button class="table-icon-btn" type="text" @click="handleDelete(scope.$index, scope.row.uid)">-->
                        <!--<i class="el-icon-delete"></i>-->
                        <!--</el-button>-->
                        <!--</template>-->
                        <!--</el-table-column>-->
                        <!--endregion-->
                </el-table>
                </div>
            </span>
            <span id="explorer-model-info">
                <div id="info-area-heading">{{ formattedHeading }}</div>
                <div class="table-wrap">
                    <el-table
                            size="mini"
                            height="calc(100vh - var(--ribbon-height) - 133px)"
                            :data="tableHighlight"
                            empty-text="Highlight a model"
                            stripe>
                        <el-table-column label="Parameter" width="90">
                            <template slot-scope="scope">
                                <b>{{ scope.row.parameter }}</b>
                            </template>
                        </el-table-column>
                        <el-table-column label="Value">
                            <template slot-scope="scope">
                                <img v-if="scope.row.parameter === 'Preview'"
                                     :src="scope.row.value" alt="Model Preview Unavailable" style="width: 100%;">
                                <span v-else-if="scope.row.parameter === 'Versions'">
                                    <el-popover
                                            placement="right"
                                            width="400"
                                            trigger="click">
                                        <el-table size="mini"
                                                  :empty-text="releasesEmptyText"
                                                  :data="modelReleases"
                                                  v-loading="$apollo.loading">
                                            <el-table-column width="67" property="version" label="Ver." align="center" fixed/>
                                            <el-table-column width="160" property="lastModifiedOn" label="Modified on" :formatter="formatterDatetime"/>
                                            <el-table-column width="120" property="lastModifiedBy" label="Modified by" :formatter="formatterModifiedBy"/>
                                            <el-table-column min-width="300" property="notes" label="Notes"/>
                                        </el-table>
                                        <el-button slot="reference" size="mini" plain @click="queryModelReleases">Load release table</el-button>
                                    </el-popover>
                                </span>
                                <span v-else>{{ scope.row.value }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </span>
        </div>
    </modeler-base>
</template>

<script>
  import ModelerBase from "./ModelerBase";
  import MenuUserModel from "./ribbon/menu_user-model/MenuUserModel";
  import ButtonIconWithText from "./_buttons/ButtonIconWithText";
  import { boolStr, capitalizeFirstLetter, decamelize } from "../assets/js/utils";
  import { removeObjectById } from "../store/helpers";
  import { mapState, mapGetters } from "vuex";
  import { apolloQuery, apolloMutate } from "../config/apollo";
  import requests from "../requests";
  import gql from 'graphql-tag';

  export default {
    name: "FileExplorer",
    components: {ModelerBase, ButtonIconWithText, MenuUserModel},

    data() {
      return {
        loading: false,
        loadingText: '',

        // QUERIED DATA
        modelsRecent: [],
        modelsOwned: [],
        modelsShared: [],
        modelReleases: [],

        // MODEL TABLE
        filterText: '',
        radio: 0,
        tableEmptyText: '',
        tableModels: [],
        // tableModelsFiltered: [],

        // HIGHLIGHT TABLE
        tableHighlight: [],
        headingHighlight: {
          name: 'Model name',
          number: 'number'
        },
        radioCurrentRow: [null, null, null],

        // RELEASE TABLE
        releasesEmptyText: 'No model releases',
      }
    },
    computed: {
      ...mapState({
        userId: state => state.session.user.Id,
        users: state => state.session.user.organization.users,
      }),
      ...mapGetters({
        getUserFullName: 'getUserFullName',
      }),
      formattedHeading() {
        const number = !this.headingHighlight.number ? '' : ' | ' + this.headingHighlight.number;
        return this.headingHighlight.name + number
      },
    },
    apollo: {
      modelsOwned: {
        skip: true,  // do not automatically call
        result({ data }) {
          // set local state of model data; make [] if null
          this.modelsOwned = data.modelsOwned ? data.modelsOwned : [];
          this.modelsShared = data.modelsShared ? data.modelsShared : [];
          this.modelsRecent = data.modelsRecent ? data.modelsRecent : [];

          // initialize table data
          this.handleChangeRadio(null, false);
        },
        // if skip is false, must use reactive variables() to capture computed Vuex state
        // PLACEHOLDER (HIGH) implement Apollo pagination, and use infinite scroll in tables
        variables: {
          limit: requests.lib.LIMIT,
        },
        query: gql`query getModels ($limit: Int) {
          modelsOwned: gearsModels (limit: $limit, query: OWNER) {${requests.model.LibraryMaster}}
          modelsShared: gearsModels (limit: $limit, query: SHARED) {${requests.model.LibraryMaster}}
          modelsRecent: gearsModels (limit: $limit, query: RECENT) {${requests.model.LibraryMaster}}
        }`,
      },
    },

    mounted() {
      this.$nextTick(() => {
        // set cursor focus
        this.$refs['filterText'].focus();
      });
    },
    methods: {
      // APOLLO
      async queryModelReleases() {
        // Query releases of currently selected model.

        // clear any existing data
        this.modelReleases = [];

        try {
          this.releasesEmptyText = 'No model releases';
          const response = await apolloQuery({
            variables: {
              Id: this.getSelectedModel().Id,
            },
            query: gql`query getReleases ($Id: ID!) {
              gearsModel (Id: $Id) {
                releases {
                  version
                  notes
                  lastModifiedOn
                  lastModifiedBy
                }
              }
            }`
          });
          this.modelReleases = response.data.gearsModel.releases;
        } catch (e) {
          if (e.message.includes('403')) {
            this.releasesEmptyText = 'Model access is forbidden.';
          }
        }
      },
      async mutateCopyModel(Id) {
        // API mutation to copy a model.
        // Returns copy of model.

        this.loading = true;
        this.loadingText = 'Copying model';

        // mutate DB
        const mutate = {
          variables: {
            Id: Id,
          },
          mutation: gql`mutation copyModel ($Id: ID!) {
            copyGearsModel (Id: $Id) {
              gearsModel {
                ${requests.model.LibraryMaster}
              }
            }
          }`,
        };
        const { data: { copyGearsModel: { gearsModel } } } = await apolloMutate(mutate).finally(() => {
          this.loading = false;
          this.loadingText = '';
        });

        // mutate local state
        this.modelsOwned.unshift(gearsModel);
        const is_shared = gearsModel.shared.includes(this.userId);
        if (is_shared) this.modelsShared.unshift(gearsModel);

        return gearsModel
      },
      async mutateDeleteModel(Id) {
        // API mutation to delete a model.
        // Returns boolean to indicate success of deletion.

        this.loading = true;
        this.loadingText = 'Deleting model';

        // mutate DB
        const mutate = {
          variables: {
            Id: Id
          },
          mutation: gql`mutation deleteModel ($Id: ID!) {
            deleteGearsModel (Id: $Id) {
              success
            }
          }`,
        };
        const { data: { deleteGearsModel: { success } } } = await apolloMutate(mutate).finally(() => {
          this.loading = false;
          this.loadingText = '';
        });

        return success;
      },

      // RADIO
      resetModelInfo() {
        // reset all model info props
        this.headingHighlight.name = 'Model name';
        this.headingHighlight.number = 'number';
        this.tableHighlight = [];
      },
      recallModelInfo() {
        // recall the row previously selected for a specific radio button
        const currentRow = this.radioCurrentRow[this.radio];

        // populate model info table and highlight the corresponding row
        this.handleCurrentChange(currentRow);
        this.$refs['tableModels'].setCurrentRow(currentRow);
      },
      handleChangeRadio(label, recall=true) {
        switch (this.radio) {
          case 0:
            this.tableModels = this.modelsRecent;
            this.tableEmptyText = "No models recently opened";
            break;
          case 1:
            this.tableModels = this.modelsOwned;
            this.tableEmptyText = "No models owned by me";
            break;
          case 2:
            this.tableModels = this.modelsShared;
            this.tableEmptyText = "No models shared with me";
            break;
          default:
            this.$message({
              type: 'error',
              message: this.$defaults.messageNotifySupport,
            })
        }
        if (recall) this.recallModelInfo();
      },

      // TABLE
      searchNumber(item, filterText) {
        if (item.number !== null) {
          return item.number.includes(filterText)
        }
      },
      getSelectedModel() {
        return this.radioCurrentRow[this.radio];
      },
      handleCurrentChange(currentRow) {
        // args: currentRow, oldCurrentRow

        if (currentRow) {
          // update model info table heading
          this.headingHighlight.name = currentRow.name;
          this.headingHighlight.number = currentRow.number;

          this.tableHighlight = [];

          // define fields to include in the highlight table
          const tableData = {
            description: currentRow.description,
            createdOn: this.$handlers.lib.localeDatetime(currentRow.createdOn),
            createdBy: this.getUserFullName(currentRow.createdBy),
            modifiedOn: this.$handlers.lib.localeDatetime(currentRow.lastModifiedOn),
            modifiedBy: this.getUserFullName(currentRow.lastModifiedBy),
            owner: this.getUserFullName(currentRow.owner),
            lock: boolStr(currentRow.lock, 'On', 'Off'),
            versions: '',
            preview: currentRow.preview,
          };

          for (let key in tableData) {
            let parameter = capitalizeFirstLetter(decamelize(key, ' '));
            this.tableHighlight.push({parameter: parameter, value: tableData[key]})
          }

          // associate the current row with the current radio button
          this.radioCurrentRow[this.radio] = currentRow;
        } else {
          // no row is highlighted, thus clear model info table
          this.resetModelInfo();
        }
      },
      formatterDatetime(row, col, val) {
        // val is a datetime
        return this.$handlers.lib.localeDatetime(val)
      },
      formatterModifiedBy(row, col, val) {
        // val is a user ID
        return this.getUserFullName(val);
      },

      // BUTTON EVENTS
      async handleNew() {
        const modelId = await this.$store.dispatch('createModel');
        this.$router.push({ name: 'openModel', params: { modelId: modelId}});
      },
      async handleCopy() {
        // copy new model (no route change)
        const copyModelId = this.getSelectedModel().Id;
        const newModel = await this.mutateCopyModel(copyModelId);

        // notification message
        this.$notify.success({
          position: this.$defaults.notifyPosition,
          title: 'Copied to owned by me',
          message: newModel.name,
        });
      },
      handleOpen() {
        // open currently selected model
        const model = this.getSelectedModel();
        this.$router.push({ name: 'openModel', params: { modelId: model.Id } });
      },
      async handleDelete() {
        // delete model (no route change)
        const modelToDelete = this.getSelectedModel();
        const Id = modelToDelete.Id;

        function onDelete() {
          removeObjectById(this.modelsRecent, Id);
          removeObjectById(this.modelsOwned, Id);
          removeObjectById(this.modelsShared, Id);
        }

        async function mutateDelete() {
          return await this.mutateDeleteModel(Id)
        }

        await this.$root.confirmDelete(modelToDelete, mutateDelete.bind(this), onDelete.bind(this));
      },
      async handleSend() {
        // Copy model URL to clipboard.

        const modelRoute = this.$router.resolve({name: 'openModel', params: {modelId: this.getSelectedModel().Id}});
        const modelUrl = process.env.VUE_APP_HOST + modelRoute.href;

        try {
          await navigator.clipboard.writeText(modelUrl);
          this.$message({
            type: 'info',
            message: 'Copied URL of model to clipboard',
            center: true,
          });
        } catch (e) {
          this.$message({
            type: 'error',
            message: 'Error, try Chrome or Firebox browser.',
            center: true,
          });
        }
      },
    },
    beforeRouteEnter(to, from, next) {
      // Called before the route that renders this component is confirmed.
      // Does NOT get called when route that renders this component has changed, see beforeRouteUpdate.
      // Does NOT have access to `this` component instance, except in next() callback.

      next(async vm => {
        // clear global state
        vm.$store.commit('RESET_MODELING');
        await vm.$apolloProvider.defaultClient.clearStore();

        // start query
        vm.$apollo.queries.modelsOwned.skip = false;
      })
    },
  }
</script>

<style scoped>
    #explorer-button-bar {
        display: grid;
        grid-auto-flow: column;
        justify-content: left;
    }

    /* LAYOUT BODY */
    #explorer-body {
        display: grid;
        grid-template-rows: auto 1fr;
        grid-template-columns: 1fr 1fr;
        grid-template-areas:
                "search none"
                "models info";
    }
    .search-models {
        /*bug workaround - class required to render style*/
        grid-area: search;
        margin-bottom: var(--font-med);
        width: calc(100% - var(--grid-col-padding));
    }
    #explorer-models {
        grid-area: models;
        padding-right: var(--grid-col-padding);
        border-right: solid var(--border-color);
        /*background-color: #66b1ff;*/
    }
    #explorer-model-info {
        grid-area: info;
        padding-left: var(--grid-col-padding);
        /*background-color: darkcyan;*/
    }

    /* TABLES */
    .table-wrap {
        /*Element-UI table width behaves strangely and is easily made dynamic to window size, hence this wrap*/
        display: grid;
        grid-template-columns: 1fr;
    }

    /* MODEL INFO */
    #info-area-heading {
        /*TUNED to align column text of info table and files table*/
        padding: .775em 0;
    }

</style>
